export const versionInfo = {
  version : '1.0.0-639bcaa',
  buildDate : '2026-11-03T17:16:56.601Z',
  commitHash : '639bcaa'
}